"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _AutoSuggestItem = _interopRequireDefault(require("./AutoSuggestItem"));

var AutoSuggestList =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(AutoSuggestList, _PureComponent);

  function AutoSuggestList() {
    var _getPrototypeOf2, _context;

    var _this;

    (0, _classCallCheck2.default)(this, AutoSuggestList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(AutoSuggestList)).call.apply(_getPrototypeOf2, (0, _concat.default)(_context = [this]).call(_context, args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onSuggestionSelect", function (suggestion) {
      _this.props.onSuggestionSelect({
        suggestion: suggestion
      });
    });
    return _this;
  }

  (0, _createClass2.default)(AutoSuggestList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          hidden = _this$props.hidden,
          suggestions = _this$props.suggestions,
          activeSuggestion = _this$props.activeSuggestion,
          suggestionBoxFooter = _this$props.suggestionBoxFooter,
          onSuggestionMouseDown = _this$props.onSuggestionMouseDown,
          onSuggestionMouseOut = _this$props.onSuggestionMouseOut;
      var classes = (0, _classnames.default)('AutoSuggestInput-suggestions', {
        'AutoSuggestInput-suggestions-hidden': hidden
      });
      return _react.default.createElement("ul", {
        className: classes
      }, (0, _map.default)(suggestions).call(suggestions, function (suggestion) {
        var id = suggestion.id,
            className = suggestion.className;
        var active = activeSuggestion && id === activeSuggestion.id;
        return _react.default.createElement(_AutoSuggestItem.default, {
          key: id,
          className: className,
          suggestion: suggestion,
          active: active,
          onSuggestionSelect: _this2._onSuggestionSelect,
          onSuggestionMouseDown: onSuggestionMouseDown,
          onSuggestionMouseOut: onSuggestionMouseOut
        });
      }), suggestionBoxFooter);
    }
  }]);
  return AutoSuggestList;
}(_react.PureComponent);

exports.default = AutoSuggestList;
(0, _defineProperty2.default)(AutoSuggestList, "defaultProps", {
  hidden: true,
  suggestions: []
});